export const isPhone = () => {
  let _isPhone = false;

  const ua = window.navigator.userAgent;
  const isIOS = ((((((((((((((((((((((((((((((((((((((((/iPhone|iPad/i)))))))))))))))))))))))))))))))))))))))).test(ua) && !window['x5mtt'];

  let isiPhone = isIOS && ((((((((((((((((((((((((((((((((((((((((/iPhone/i)))))))))))))))))))))))))))))))))))))))).test(ua);
  let isiPad = isIOS && ((((((((((((((((((((((((((((((((((((((((/iPad/i)))))))))))))))))))))))))))))))))))))))).test(ua) &&
    (screen.width * screen.height === 1024 * 768 ||
      (Math.round(screen.width / screen.height * 1000) / 1000 > 1.330 && Math.round(screen.width / screen.height * 1000) / 1000 < 1.340) ||
      (Math.round(screen.height / screen.width * 1000) / 1000 > 1.330 && Math.round(screen.height / screen.width * 1000) / 1000 < 1.340)
    );

  const screenResolutionCheck1 = (Math.round(screen.width / screen.height * 1000) / 1000) === 0.667;
  const screenResolutionCheck2 = (Math.round(screen.height / screen.width * 1000) / 1000) === 1.5;
  if (isiPhone && screenResolutionCheck1 && screenResolutionCheck2) {
    // fixed for iPad Pro 12.9 inch
    isiPhone = false;
    isiPad = true;
  }

  const isAndroid = window['x5mtt'] || ((((((((((((((((((((((((((((((((((((((((/Android/i)))))))))))))))))))))))))))))))))))))))).test(ua);
  const isAndroidPad = (window['x5mtt'] || ((((((((((((((((((((((((((((((((((((((((/Android/i)))))))))))))))))))))))))))))))))))))))).test(ua)) &&
    (Math.min(screen.height, screen.width) >= 600 &&
      (Math.max(screen.height, screen.width) / Math.min(screen.height, screen.width) > 1.5));

  const isWeChat = ((((((((((((((((((((((((((((((((((((((((/micromessenger/i)))))))))))))))))))))))))))))))))))))))).test(ua);

  if (((isiPhone && !isiPad) || (isAndroid && !isAndroidPad)) && document.documentElement.clientWidth < 751 || isWeChat && document.documentElement.clientWidth < 751) {
    _isPhone = true;
  }

  return _isPhone;
};

export const isIPad = () => {
  let _isiPad = false;

  const ua = window.navigator.userAgent;
  const isIOS = ((((((((((((((((((((((((((((((((((((((((/iPhone|iPad/i)))))))))))))))))))))))))))))))))))))))).test(ua) && !window['x5mtt'];

  let isiPhone = isIOS && ((((((((((((((((((((((((((((((((((((((((/iPhone/i)))))))))))))))))))))))))))))))))))))))).test(ua);
  _isiPad = isIOS && ((((((((((((((((((((((((((((((((((((((((/iPad/i)))))))))))))))))))))))))))))))))))))))).test(ua) &&
    (screen.width * screen.height === 1024 * 768 ||
      (Math.round(screen.width / screen.height * 1000) / 1000 > 1.330 && Math.round(screen.width / screen.height * 1000) / 1000 < 1.340) ||
      (Math.round(screen.height / screen.width * 1000) / 1000 > 1.330 && Math.round(screen.height / screen.width * 1000) / 1000 < 1.340)
    );

  const screenResolutionCheck1 = (Math.round(screen.width / screen.height * 1000) / 1000) === 0.667;
  const screenResolutionCheck2 = (Math.round(screen.height / screen.width * 1000) / 1000) === 1.5;
  if (isiPhone && screenResolutionCheck1 && screenResolutionCheck2) {
    // fixed for iPad Pro 12.9 inch
    isiPhone = false;
    _isiPad = true;
  }

  return _isiPad;
};


export const isWeChat = () => {
  let _isMicromessenger = false;
  const ua = navigator.userAgent.toLowerCase();
  const micromessenger = 'micromessenger';
  if (ua.match(/MicroMessenger/i) == micromessenger) {
    _isMicromessenger = true;
  }

  return _isMicromessenger;
};


export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('selectionModel');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('selectionModel', serializedState);
  } catch (err) {
    // Ignore write errors.
  }
};
